// extracted by mini-css-extract-plugin
export default {"tabItem":"tab_menu_tabItem__oDJyZ","tabItemActive":"tab_menu_tabItemActive__RM7bD"};